import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectButtonModule } from 'primeng/selectbutton';
import { BaseControlComponent } from './base-control.component';
import { HelpTextComponent } from './help-text.component';
@Component({
  selector: 'app-select-button',
  imports: [
    ReactiveFormsModule,
    CommonModule,
    CheckboxModule,
    HelpTextComponent,
    SelectButtonModule,
  ],
  template: `
    <p-selectbutton
      [options]="options"
      [formControl]="control"
      [optionLabel]="optionLabel"
      [optionValue]="optionValue"
      [multiple]="multiple"
    >
      @if (optionAriaLabel) {
        <ng-template #item let-item>
          <span aria-hidden="true">{{ item[optionLabel] }}</span>
          <span class="tw-sr-only">{{ item[optionAriaLabel] }}</span>
        </ng-template>
      }
    </p-selectbutton>

    @if (showHelpText) {
      <app-help-text [control]="control" [helpText]="helpText" />
    }
  `,
  styles: ``,
})
export class SelectButtonComponent
  extends BaseControlComponent
  implements OnInit
{
  @Input({ required: true })
  optionLabel: string;

  @Input()
  optionValue: string;

  @Input()
  optionAriaLabel: string;

  @Input({ required: true })
  options: any[];

  @Input()
  multiple = false;

  ngOnInit(): void {
    this.showHelpText = !!this.helpText;
  }
}
